export default "__VITE_ASSET__BAUqmCsJ__"